import { Link } from "react-router-dom";
import { Navbar, Nav, Container } from "react-bootstrap";
import "../styles/Navigation.css"; // Custom styling
import   AddCustomer from './customers/CustomerForm'
import  ViewCustomer  from './customers/ViewCustomer'

import { Routes, Route } from "react-router-dom";
import HomeAdmin from "./HomeAdmin";
import CustomerManagement from "./customers/CustomerManagement";
import ManageOrders from "./orders/OrderList";
import OrderDetails from "./orders/OrderView"
import UpdateTracking  from './orders/UpdateTracking'
import OrderPyament from './orders/UpdatePayment'
import ManagePayments from './pyaments/PaymentList'
import  NotFound  from '../pages/NotFound'
import UpdateCustomer  from "./customers/UpdateCustomer";
import UpdateAdminProfile from "./UpdateAdminProfile";
import UpdatePayment from "./pyaments/UpdatePayment";
import SalesReport  from './reprots/SalesReport'
import OrderReport  from './reprots/OrderReport'
import CustomerReport from './reprots/CustomerReport'
import  BlockedCustomer from './customers/BlockedCustomers'
import FaildList     from  './customers/FailedAttemptsList'
import  ManageBread  from './items/ItemManager'

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomeAdmin />}>
        <Route index element={<h1>Admin Dashboard</h1>} /> {/* Home content */}
        <Route path="manageCustomers" element={<CustomerManagement />} />
        <Route path="customers/add" element={<AddCustomer />} />
        <Route path="customers/view/:id" element={<ViewCustomer />} />
        <Route path="customers/edit/:id" element={<UpdateCustomer />} />
        <Route path="payment/:orderId" element={<OrderPyament />} /> 
        <Route path="manageOrders" element={<ManageOrders />} /> 
        <Route path="managePayments" element={<ManagePayments />} /> 
        <Route path="editTracking/:orderId/:customerId" element={<UpdateTracking />} />
        <Route path="manageBread" element={<ManageBread />} />
        <Route path="viewOrder/:id" element={<OrderDetails />} /> 
        <Route path="profile" element={<UpdateAdminProfile />} /> 
        <Route path="payments/update/:payment_id" element={<UpdatePayment />} />
        <Route path="reports/sales" element={<SalesReport />} />
        <Route path="reports/orders" element={<OrderReport />} />
        <Route path="reports/customers" element={<CustomerReport />} />
        <Route path="customers/blocked" element={<BlockedCustomer />} />
        <Route path="customers/fail" element={<FaildList />} />
      </Route>
       <Route path="*" element={<NotFound />} />

    </Routes>
  );
};

export default AdminRoutes;